export default "__VITE_ASSET__Dp5t3DJa__"